module.exports = __webpack_public_path__ + "static/media/corner_bg.a4712cf1.svg";